export enum ClearTextModeEnum {
  Buffer = 0,
  Overlay = 1
}

export type ClearTextMode =
  | ClearTextModeEnum.Buffer
  | ClearTextModeEnum.Overlay;
